// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"9029a4a0","304":"a3621678","453":"f9db1f37","501":"bb72798a"}[chunkId] + ".chunk.js";
};